import React, {
  useState,
} from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import {
  Modal,
  ModalFooter,
  Button,
  TextArea,
} from '@folio/stripes/components';
import css from './cancel-job-confirmation-modal.css';
import { validateFieldLength } from '../../../utils';
import { DESCRIPTION_LIMIT_MAX } from '../../../constants';

const CancelJobConfirmationModal = ({
  isOpen,
  onCancel,
  onConfirm,
}) => {
  const [cancelJobComment, setCancelJobComment] = useState('');

  const setValue = ({ target: { value } }) => {
    setCancelJobComment(value);
  };

  const confirmCancel = () => onConfirm(cancelJobComment);

  const validatedField = () => validateFieldLength(cancelJobComment, DESCRIPTION_LIMIT_MAX);

  const getCancelJobForm = () => {
    const textAreaLabel = () => (
      <span className={css.textAreaLabel}>
        <FormattedMessage id="ui-task-list.confirmationCancelJobModal.inputLabel.job" />
      </span>
    );

    return (
      <>
        <FormattedMessage id="ui-task-list.confirmationCancelJobModal.message.job" />
        <div
          data-test-cancel-job-comment-input
          className={css.inputWrapper}
        >
          <TextArea
            error={validatedField()}
            label={textAreaLabel()}
            onChange={setValue}
          />
        </div>
      </>
    );
  };

  const getFooter = (
    <ModalFooter>
      <Button
        data-test-cancel-job-confirm
        buttonStyle="primary"
        disabled={!!validatedField()}
        onClick={confirmCancel}
      >
        <FormattedMessage id="ui-task-list.confirmationCancelJobModal.confirm" />
      </Button>
      <Button
        data-test-cancel-job-cancel
        onClick={onCancel}
      >
        <FormattedMessage id="ui-task-list.confirmationCancelJobModal.cancel" />
      </Button>
    </ModalFooter>
  );

  return (
    <Modal
      footer={getFooter}
      id="confirm-cancel-job-action"
      label={<FormattedMessage id="ui-task-list.confirmationCancelJobModal.heading.job" />}
      open={isOpen}
    >
      {getCancelJobForm()}
    </Modal>
  );
};

CancelJobConfirmationModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default CancelJobConfirmationModal;
